<app-dialog
	modalTitle="Clientes e organizações"
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	(dialogClose)="closeModal()"
	(dialogSave)="saveItems()"
>
	<ul class="mb-fix">
		<ng-container *ngFor="let org of data.organizations">
			<li>
				<mat-checkbox
					color="primary"
					class="ml-xs mt-nano mb-nano"
					[checked]="resultIds.includes(org.id)"
					[disabled]="data.disabled === org.id"
					(change)="onCheckboxToggle(org.id, $event.checked)"
				>
					{{ org.name }}
				</mat-checkbox>
			</li>
			<li *ngFor="let sub of org.secondary">
				<mat-checkbox
					color="primary"
					class="ml-md mt-nano mb-nano"
					[checked]="resultIds.includes(sub.id)"
					[disabled]="data.disabled === sub.id"
					(change)="onCheckboxToggle(sub.id, $event.checked)"
				>
					{{ sub.name }}
				</mat-checkbox>
			</li>
		</ng-container>
	</ul>
</app-dialog>
